export default __webpack_public_path__ + "static/media/Kaizen Institute.807fdf6f.png";